export enum EWildWheelFeatureStates {
    WILD_WHEEL_HIDDEN = 'WILD_WHEEL_HIDDEN',
    WILD_WHEEL_START = 'WILD_WHEEL_START',
    WILD_WHEEL_SPIN = 'WILD_WHEEL_SPIN',
    WILD_WHEEL_RESULT = 'WILD_WHEEL_RESULT',
    WILD_WHEEL_END = 'WILD_WHEEL_END',
    WILD_WHEEL_MERGE_START = 'WILD_WHEEL_MERGE_START',
    WILD_WHEEL_MERGE_END = 'WILD_WHEEL_MERGE_END'
}
